import { render } from "./PriceModalContent.vue?vue&type=template&id=2c758b35&scoped=true"
import script from "./PriceModalContent.vue?vue&type=script&lang=js"
export * from "./PriceModalContent.vue?vue&type=script&lang=js"

import "./PriceModalContent.vue?vue&type=style&index=0&id=2c758b35&lang=scss&scoped=true"

import exportComponent from "/Users/suzukitatsuya/kaon_r-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c758b35"]])

export default __exports__